var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14C4.74103 13.9962 4.12563 13.3727 4.11813 12.6H6.86812C6.86958 12.7872 6.83453 12.9727 6.765 13.146C6.58464 13.5674 6.21625 13.8748 5.775 13.972H5.77156H5.76125H5.74888H5.74269C5.66281 13.9889 5.58157 13.9983 5.5 14ZM11 11.9H0V10.5L1.375 9.8V5.95C1.33878 4.96238 1.55783 3.98239 2.01025 3.108C2.46059 2.29706 3.23035 1.72121 4.125 1.526V0H6.875V1.526C8.64806 1.9558 9.625 3.5266 9.625 5.95V9.8L11 10.5V11.9Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/NotifIcon.fadc5f8f1ad0623789e4b5ca24cc0671.svg";
export { ForwardRef as ReactComponent };